import app from 'app';
import Marionette from 'backbone.marionette';
import * as Sentry from '@sentry/vue';

// language=Vue
const NurseVue = app.Vue.extend({
  data: () => ({ errors: 0 }),
  computed: {
    counter() {
      return this.errors > 9 ? '💥' : this.errors;
    },
  },
  name: 'NurseVue',
  template: `
<div>
    <span class="-counter">{{counter}}</span>
    <wt-svg-animation v-if="counter < 10" name="bug" :play="counter > 1"/>
    <wt-svg-animation v-else name="bugs" :play="true"/>
</div>
`.normalizeSpace(),
});

app.namespace.Controller.DoctorController = Marionette.Object.extend({
  /**
   * internal error cache
   * {Number} timestamp: {ErrorEvent} window.error.originalEvent
   */
  problem: null,

  initialize: function (/* options*/) {
    $(window).on('error', this._window_error.bind(this));

    if (!app.rootStore.getters['user/box'].isProd()) {
      this.$nurse = $('.js-doctor-nurse');
      this.nurseVue = new NurseVue();
      this.$nurse.append(this.nurseVue.$mount().$el);
      this.$nurse.on(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          try {
            const message = [];
            if (this.problem) {
              this.problem.forEach(function (value, key) {
                message.push(key + ': ' + value);
              });
              alert(message.join('\n'));
            }
          } catch (ex) {
            // catch
          }
        }.bind(this)
      );
    }
  },

  /**
   *
   * @param e {jQuery.Event}
   * @private
   */
  _window_error: function (e) {
    if (arguments.length === 1 && !this._ignoredErrorEvent(e.originalEvent)) {
      this._handleError(e.originalEvent.message);
    }
  },

  /**
   * @param bug {ErrorEvent}
   * @return {boolean}
   * @private
   */
  _ignoredErrorEvent: function (bug) {
    if (/Script error/i.test(bug.message)) {
      if (!bug.filename) {
        return true;
      }
      // investigate who throws it
      // debugger;
    }

    return /tinymce/i.test(bug.filename);
  },

  /**
   * Choose what you do with the error
   * @param message {String}
   * @private
   */
  _handleError: _.handleException(function (message) {
    if (!app.rootStore.getters['user/box'].isProd()) {
      if (!this.problem) {
        this.problem = new Map();
      }

      this.problem.set(Date.now(), message);

      // visual indication
      this.nurseVue.errors = this.problem.size;
      if (this.problem.size <= 1) {
        this.$nurse.show().animate({ left: '60' });
      }
    }
  }),

  /**
   * @param data {object}
   * @private
   */
  _sendLog: function (data) {
    data = Object.assign(
      {
        applicationIdentifier: 'creator?',
        applicationVersion: serverProfile.version,
        userId: app.rootStore.getters['user/id'],
        clientTime: new Date().toString(),
        logLevel: 'INFO',
        message: '',
      },
      data
    );

    $.ajax({
      url: app.apiUrl('/api/v1/monitoring/logs'),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify([data]),
    });
  },

  /**
   * send report to backend and if not at prod show visual indication
   * @param message {String}
   * @param [bug] {Error}
   * @param [options] {Object}
   */
  report: function (message, bug, options = {}) {
    if (!(bug instanceof Error)) {
      bug = new Error();
      bug.name = '';
      bug.message = message;
    }
    if (app.rootStore.getters['user/box'].isDev()) {
      console.groupCollapsed('%c' + message, 'color: #f3500f');
      console.trace(bug, bug && bug.stack);
      console.groupEnd();
    } else {
      console.error(message, bug);
    }

    if (
      serverProfile.environment === 'prod' ||
      serverProfile.environment === 'test'
    ) {
      Sentry.withScope((scope) => {
        for (const key in options) {
          if (Object.getOwnPropertyDescriptor(options, key)) {
            scope.setExtra(key, options[key]);
          }
        }
        scope.setExtra('doctorController', message);
        Sentry.captureException(bug);
      });
    }

    this._handleError(message);
  },

  reportPreviewStreaming: _.handleException(function (
    assetUUID,
    assetType,
    ms
  ) {
    const seconds = (ms / 1e3).toFixed(3);
    this._sendLog({
      message: `PreviewStreaming time until the first part
        assetUUID=${assetUUID}
        assetType=${assetType}
        PreviewStreamingFirstPartTime=${seconds}
      `.normalizeSpace(),
    });
  }),

  reportFullPreviewStreaming: _.handleException(function (ms) {
    const seconds = (ms / 1e3).toFixed(3);
    this._sendLog({
      message: `FullPreviewStreaming time until the first part FullPreviewStreamingFirstPartTime=${seconds}`,
    });
  }),

  reportStaticPreview: _.handleException(function (previewId, asset, seconds) {
    this._sendLog({
      message: `Static preview time assetUUID=${asset.metadata.assetUUID} previewId=${previewId} time=${seconds}`,
    });
  }),
});
